import { ParticipantListItem } from "../components/Forms/Permits/ParticipantsList";
import PersonFormElement, { PersonFormElement_default } from "./forms/PersonFormElement";

type Person = {
    name: string;
    phoneNumber: string;
    isActive: boolean;
};

export default Person;

export function fromParticipantListItem(participantListItem: ParticipantListItem): Person {
    const person: Person = {
        name: participantListItem.name,
        phoneNumber: participantListItem.phoneNumber,
        isActive: participantListItem.isActive
    };

    return person;
}

export function Person_toFormElement(person: Person): PersonFormElement {
    if (!person) {
        console.error("Person is null or undefined");
        return PersonFormElement_default();
    }

    const personFormElement: PersonFormElement = {
        isActive: person.isActive,
        name: person.name,
        phoneNumber: person.phoneNumber,
        nameErrorMessage: "",
        phoneNumberErrorMessage: ""
    };

    return personFormElement;
}

export function Person_toParticipantListItem(person: Person, index: number): ParticipantListItem {
    const participantListItem: ParticipantListItem = {
        index: index,
        isActive: person.isActive,
        name: person.name,
        phoneNumber: person.phoneNumber
    };

    return participantListItem;
}

export function Person_default(): Person {
    return {
        name: "",
        phoneNumber: "",
        isActive: false
    };
}
